import { ClockBarComponent } from './clock-bar/clock-bar.component';
import { ClockChipGroupComponent } from './clock-chip-group/clock-chip-group.component';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    ClockBarComponent,
    ClockChipGroupComponent
  ],
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgbTooltipModule
  ],
  exports: [
    ClockBarComponent,
    ClockChipGroupComponent
  ]
})
export class ClockModule { }
